import { LicenseAppType, OrganisationOUT, PagedBuildingOUT } from "api-client";
import { makeAutoObservable } from "mobx";
import { buildingStore } from "store/Building/BuildingStore";
import { localStorageKeys } from "utils";

export interface OrganisationBuildings extends PagedBuildingOUT {
  loading: boolean;
}

class SidebarMenuStore {
  currentOrganisation: OrganisationOUT | undefined = undefined;
  currentOrgBuildings: OrganisationBuildings = {
    count: 0,
    items: [],
    loading: true,
  };
  menuIndex: number = 0;
  organisationID: string | undefined = undefined;

  setCurrentOrganisation(defaultOrganisation: OrganisationOUT | undefined) {
    this.currentOrganisation = defaultOrganisation;
  }

  setOrganisationID(organisationID: string | undefined) {
    this.organisationID = organisationID;
  }

  setCurrentOrgBuildings(currentOrgBuildings: OrganisationBuildings) {
    this.currentOrgBuildings = currentOrgBuildings;
  }

  setMenuIndex(index: number) {
    this.menuIndex = index;
  }

  async getCurrentOrgBuildings(org_id?: string) {
    this.setCurrentOrgBuildings({ count: 0, items: [], loading: true });
    const orgID = org_id ?? this.currentOrganisation?.id;
    if (!orgID) return;
    const response = await buildingStore.getOrganisationBuildings(orgID);
    response &&
      this.setCurrentOrgBuildings({
        count: response.count,
        items: response.items.sort((a, b) => a.name.localeCompare(b.name)),
        loading: false,
      });
  }

  hasOrganisationAssetLicense() {
    return this.currentOrganisation?.license?.app === LicenseAppType.Asset;
  }

  async onChangeOrganisation(organisation: OrganisationOUT) {
    localStorage.setItem(
      localStorageKeys.DEFAULT_ORGANISATION_KEY,
      organisation.id
    );
    this.setCurrentOrgBuildings({ count: 0, items: [], loading: true });
    this.setCurrentOrganisation(organisation);
    await this.getCurrentOrgBuildings();
  }

  getCurrentLicense() {
    return this.currentOrganisation && this.menuIndex === 0
      ? this.currentOrganisation?.license?.app
      : buildingStore.currentBuilding?.license?.app;
  }

  constructor() {
    makeAutoObservable(this);
  }

  static instance: SidebarMenuStore;

  static getInstance(): SidebarMenuStore {
    if (!SidebarMenuStore.instance) {
      SidebarMenuStore.instance = new SidebarMenuStore();
    }
    return SidebarMenuStore.instance;
  }
}

export const sidebarMenuStore = SidebarMenuStore.getInstance();
